var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import Modal from 'react-modal';
import { MediaExplorer } from './index';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-regular-svg-icons/faTimes';
import { faPen } from '@fortawesome/pro-regular-svg-icons/faPen';
import { faSpinner } from '@fortawesome/pro-regular-svg-icons/faSpinner';
import { MediaExplorerWrapper, ImageCloseWrapper, Button, ImageHoverBg, } from './styles';
export var MediaExplorerPopover = function (_a) {
    var appId = _a.appId, scope = _a.scope, onSelectFile = _a.onSelectFile, children = _a.children, selectedFile = _a.selectedFile, mediaBucketURL = _a.mediaBucketURL, iconBucketURL = _a.iconBucketURL, fileBucketURL = _a.fileBucketURL, aptVersion = _a.aptVersion, acceptedTypes = _a.acceptedTypes, _b = _a.isMediaModal, isMediaModal = _b === void 0 ? true : _b, PermissionsWrapper = _a.PermissionsWrapper, _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.imageHover, imageHover = _d === void 0 ? false : _d, _e = _a.width, width = _e === void 0 ? 0 : _e, _f = _a.fullWidth, fullWidth = _f === void 0 ? false : _f, _g = _a.hideClearButton, hideClearButton = _g === void 0 ? false : _g, _h = _a.imageLoading, imageLoading = _h === void 0 ? false : _h;
    var _j = useState(false), isOpen = _j[0], setIsOpen = _j[1];
    var handleSelectFile = function (e) {
        onSelectFile(e);
        setIsOpen(false);
    };
    var togglePopover = function () {
        if (!disabled) {
            setIsOpen(!isOpen);
        }
    };
    return (_jsxs(_Fragment, { children: [_jsxs(MediaExplorerWrapper, __assign({ style: fullWidth ? {} : { width: width || 'fit-content' }, fullWidth: true }, { children: [_jsxs(ImageCloseWrapper, __assign({ disabled: disabled, onClick: togglePopover, fullWidth: true }, { children: [imageHover && hideClearButton && (_jsx(ImageHoverBg, { children: _jsx(FontAwesomeIcon, { color: "black", size: "1x", icon: faPen }) })), imageLoading && (_jsx(ImageHoverBg, { children: _jsx(FontAwesomeIcon, { color: "black", size: "1x", spin: true, icon: faSpinner }) })), children] })), !!selectedFile && !hideClearButton && (_jsx(Button, __assign({ onClick: function () { return handleSelectFile({ url: '', type: 'text' }); } }, { children: _jsx(FontAwesomeIcon, { color: "white", size: "1x", icon: faTimes }) })))] })), _jsx(Modal, __assign({ isOpen: isOpen, onRequestClose: function () { return setIsOpen(false); }, style: {
                    content: {
                        height: '549px',
                        width: '800px',
                        top: '50%',
                        left: '50%',
                        right: 'auto',
                        bottom: 'auto',
                        marginRight: '-50%',
                        transform: 'translate(-50%, -50%)',
                        boxShadow: '2px 2px 16px rgba(0, 0, 0, 0.2)',
                        borderRadius: '8px',
                        padding: '0',
                    },
                    overlay: {
                        backgroundColor: 'rgba(0, 0, 0, 0.25)',
                    },
                }, ariaHideApp: false, contentLabel: "Media" }, { children: _jsx(MediaExplorer, { appId: appId, scopeToUse: scope, aptVersion: aptVersion, setIsOpen: setIsOpen, fileBucketURL: fileBucketURL, iconBucketURL: iconBucketURL, acceptedTypes: acceptedTypes, mediaBucketURL: mediaBucketURL, onSelectFile: handleSelectFile, isMediaModal: isMediaModal, PermissionsWrapper: PermissionsWrapper }) }))] }));
};
